import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from '@tekman/onmat/service/generic';
import { LearnWordsResponse, LearnWordsUsername } from '@tekman/shared/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LearnWordsService {
  constructor(private readonly http: HttpClient, private readonly env: EnvironmentService) {}

  authenticate(endpoint: string, user: LearnWordsUsername): Observable<LearnWordsResponse> {
    const headers: HttpHeaders = new HttpHeaders().append('Lw-Client', this.env.settings.learnWords.clientId);
    return this.http.post<any>(endpoint, user, {
      headers,
    });
  }
}
